import React from 'react';
import { TestimonialCard } from './TestimonialCard';
import { testimonials } from '../data/testimonials';
export function Testimonials() {
  return <section aria-label="Family testimonials" className="bg-transparent" data-id="element-191" data-mp="3ksgyi97eejdg">
      <div className="mx-auto max-w-6xl px-5 py-10" style={{
      paddingTop: "17px",
      paddingBottom: "19px"
    }} data-id="element-192" data-mp="3fyco1fyxbt7m">
        <h2 className="text-center font-display text-2xl font-black text-plum sm:text-3xl" data-id="element-193" data-mp="3b01fd8kd7oqz">
          🗣️ Families who transformed their routines
        </h2>
        <p className="mt-3 text-center text-sm text-plum/60" data-id="element-194" data-mp="31zd24g2spsf5">
          Real stories from parents using The Autonomous Child Visual System™
        </p>
        <div className="mt-8 grid w-full grid-cols-1 gap-5 md:grid-cols-3 md:gap-6" data-id="element-195" data-mp="2x2w2opq5brmr">
          {testimonials.map((t, i) => <TestimonialCard key={t.name} testimonial={t} delay={i * 0.1} data-id="element-196" data-mp="2s4319vo4vr2y" data-mpi={i} />)}
        </div>
      </div>
    </section>;
}